import { AxiosResponse } from 'axios';
import { getRequest, postRequest, RESPONSE_STATUS_OK } from '../../Services/HttpService';
import JSONValidationService from '../../Services/JSONValidationService';
import MainMenuSchema from './MainMenuSchema.json';
import { IMenuItemsApiResponse, MenuSettingsResponse, MenuSettingsValue } from './types';

export type { MenuSettingsValue, MenuSettingsResponse };

export const DEFAULT_MENU_SETTINGS: MenuSettingsValue = { open: false };

export const getMenuSettings = async (): Promise<MenuSettingsValue> => {
  const response = await getRequest<MenuSettingsResponse>('/v1/user-settings/menu', {
    showErrorToaster: false,
    showToaster: false,
    returnAxiosResponse: true,
  });

  if (response && (response as unknown as AxiosResponse).status === 200) {
    const data = (response as unknown as AxiosResponse<MenuSettingsResponse>).data;
    if (data.status === RESPONSE_STATUS_OK && typeof data.settings?.value?.open === 'boolean') {
      return { open: data.settings.value.open };
    }
  }

  return DEFAULT_MENU_SETTINGS;
};

export const saveMenuSettings = async (open: boolean): Promise<MenuSettingsValue | null> => {
  const response = await postRequest<{ open: boolean }, MenuSettingsResponse>(
    '/v1/user-settings/menu/save',
    { open },
    {
      showErrorToaster: false,
      showToaster: false,
      returnAxiosResponse: true,
    }
  );

  if (response && (response as unknown as AxiosResponse).status === 200) {
    const data = (response as unknown as AxiosResponse<MenuSettingsResponse>).data;
    if (data.status === RESPONSE_STATUS_OK && data.settings?.value) {
      return data.settings.value;
    }
  }

  return null;
};

export const getMenuItems = async (): Promise<any> => {
  const response = await getRequest<IMenuItemsApiResponse>('/v1/menu-items/list', {});
  if (response) {
    JSONValidationService.validateSchema(MainMenuSchema, response, 'Main menu Data Schema');
    return response;
  }
  return false;
};

export const iconSwitcher = (cssName: string) => {
  const cssProp = ' cmd-font-stack-1x';

  switch (cssName) {
    case 'map':
      return `cmd-icon cmd-icon-map ${cssProp}`;
    case 'rideBook':
      return `cmd-icon cmd-icon-driving-overview ${cssProp}`;
    case 'reports':
      return `cmd-icon cmd-icon-report ${cssProp}`;
    case 'refuelings':
      return `cmd-icon cmd-icon-refueling-overview ${cssProp}`;
    case 'costs':
      return `cmd-icon cmd-icon-cost-overview ${cssProp}`;
    case 'corrections':
      return `cmd-icon cmd-icon-odometer ${cssProp}`;
    case 'settings':
      return `cmd-icon cmd-icon-cog ${cssProp}`;
    case 'alarms':
      return `cmd-icon cmd-icon-alarm-2 ${cssProp}`;
    case 'expenseImports':
      return `cmd-icon cmd-icon-import`;
    case 'bluecoins':
      return `cmd-icon cmd-icon-bluecoin`;
    case 'comparator':
      return `cmd-icon cmd-icon-report ${cssProp}`;

    default:
      return `cmd-icon cmd-icon-error ${cssProp}`;
  }
};
